import React, {Component} from "react";
import CustodiaBBVAView from "./CustodiaBBVAView";
import ConfirmationMessage from "../../components/confirmationMessage";
import {Growl} from "primereact/growl";
import {CustodyBBVAService} from "../../service/custody/CustodyBBVAService";
import {isValidDomain} from "../../utils/validator/Session";
import {Checkbox} from 'primereact/checkbox';

export default class CustodiaBBVAContainer extends Component {
    constructor(props) {
        super(props);

        this.custodyService = new CustodyBBVAService();
        this.confirmationRefEnabled = null;
        this.setConfirmationRefEnabled = element => {
            this.confirmationRefEnabled = element
        };
        this.setConfirmationRefSave = element => {
            this.confirmationRefSave = element
        };

        this.state = {
            isLoading: false,
            username: '',
            password: '',
            baseUrl: '',
            trustClient: '',
            isDisabledData: true,
            oldData: {},
            tabItems: [
                {label: 'Parametrización Datos de Conexión',},
                {label: 'Parametrización Instituciones',},
            ],
            activeIndex: this.props.location.activeIndex ?
                this.props.location.activeIndex : 0,
            dataInstitutions: [],
            dataInstitutionsMap:{},
            isSaveInstitutions: false,
        };

        this.onChangeData = this.onChangeData.bind(this);
        this.openConfMsgEnabled = this.openConfMsgEnabled.bind(this);
        this.openConfMsgSave = this.openConfMsgSave.bind(this);
        this.saveDataFideicomiso = this.saveDataFideicomiso.bind(this);
        this.enableForm = this.enableForm.bind(this);
        this.restartData = this.restartData.bind(this);
        this.getCustodyBBVAData = this.getCustodyBBVAData.bind(this);
        this.saveDataFideicomisoConf = this.saveDataFideicomisoConf.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
        this.getInstitutionsData = this.getInstitutionsData.bind(this);
        this.automaticTemplate = this.automaticTemplate.bind(this);
        this.saveDataInstitutions = this.saveDataInstitutions.bind(this);
        this.openConfMsgSaveInst = this.openConfMsgSaveInst.bind(this);
        this.loading = this.loading.bind(this);
    }

    /**
     * Función que setea la variable para que se vea la barra de carga
     */
    loading(opt) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: opt ? opt : false,
            });
        }
    }

    componentDidMount() {
        this.getCustodyBBVAData();
        this.getInstitutionsData();
    }

    getCustodyBBVAData() {
        this.loading(true);
        this.custodyService.getCustodyData().then(res => {

            let oldDataAux = res.payload;
            this.setState({
                oldData: oldDataAux,
                username: oldDataAux.username,
                password: oldDataAux.password,
                baseUrl: oldDataAux.baseUrl,
                trustClient: oldDataAux.trustClient,
            });
            this.loading(false);
        });
    }

    getInstitutionsData(){
        this.loading(true);
        this.custodyService.getInstitutionsData().then(res =>{
            let catInst = res.filter(e=> e.registered);
            let institutionMap = new Map();
            catInst.forEach(inst => {
                institutionMap.set(inst.institutionId, inst);
            })
            this.setState({
                dataInstitutions: catInst,
                dataInstitutionsMap: institutionMap,
            })

            this.loading(false)
        })
    }

    saveDataFideicomisoConf(){
        let isSaveInstitutionsAux = this.state.isSaveInstitutions;
        if (isSaveInstitutionsAux){
            this.saveDataInstitutions();
            this.setState({
                isSaveInstitution: false,
            })
        } else {
            let data = {
                username: this.state.username,
                password: this.state.password,
                baseUrl: this.state.baseUrl,
                trustClient: this.state.trustClient
            }
            this.saveDataFideicomiso(data);
        }
    }

    restartData() {
        this.setState({
            username: this.state.oldData.username,
            password: this.state.oldData.password,
            baseUrl: this.state.oldData.baseUrl,
            trustClient: this.state.oldData.trustClient,
        });
        this.saveDataFideicomiso(this.state.oldData);
    }

    saveDataFideicomiso(data) {
        this.loading(true);
        this.custodyService.updateCustodyData(
            data.username, data.password, data.baseUrl, data.trustClient
        ).then(resp => {
            if (resp.success === false) {
                this.growl.show({
                    severity: 'error', summary: 'Error.',
                    detail: resp.error
                });
            } else {
                this.growl.show({
                    severity: 'success', summary: 'Éxito.',
                    detail: 'Se ha guardado su solicitud con éxito.'
                });
                this.setState({
                    isDisabledData: true,
                });
            }
            this.loading(false);
        });
    }

    saveDataInstitutions(){
        this.loading(true);
        this.custodyService.updateInstitutionsData(this.state.dataInstitutions).then(resp => {
            if (resp.success === false) {
                this.growl.show({
                    severity: 'error', summary: 'Error.',
                    detail: 'Error al guardar.'
                });
            } else {
                this.growl.show({
                    severity: 'success', summary: 'Éxito.',
                    detail: 'Se ha guardado su solicitud con éxito.'
                });
            }
            this.setState({
                activeIndex: 0,
            });
            this.getInstitutionsData();
            this.loading(false);
        });
    }

    onChangeData(event) {
        const {name, value} = event.target;
        this.setState({[name]: value})
    }

    enableForm() {
        this.setState({
            isDisabledData: false,
        })

    }

    openConfMsgEnabled() {
        if (this.confirmationRefEnabled) {
            this.confirmationRefEnabled.openConfirmationMessage();
        }
    }

    openConfMsgSave() {
        if (this.state.username === '' || this.state.username === null
            || this.state.password === '' || this.state.password === null
            || this.state.baseUrl === '' || this.state.baseUrl === null
            || this.state.trustClient === ''|| this.state.trustClient === null) {
            this.growl.show({
                severity: 'error', summary: 'Error.',
                detail: 'Los datos están incompletos'
            });
        } else {
            /**
             * Validar dominio
             */
            if (isValidDomain(this.state.baseUrl)) {
                if (this.confirmationRefSave) {
                    this.confirmationRefSave.openConfirmationMessage();
                }
            } else {
                this.growl.show({
                    severity: 'error', summary: 'Error.',
                    detail: 'Llenar el dominio correctamente.'
                });
                this.loading(false);
            }
        }
    }

    openConfMsgSaveInst() {
        if (this.confirmationRefSave) {
            this.confirmationRefSave.openConfirmationMessage();
            this.setState({
                isSaveInstitutions:true,
            });
        }
    }

    /**
     * Función que guarda el cambio de tab en la vista.
     * @param event
     */
    handleTabChange = event => {
        this.setState({activeIndex: event.index})
    }

    onChangeAutomaticCheck(rowData) {
        let instMap = this.state.dataInstitutionsMap;
        let mapElem = instMap.get(rowData.institutionId);
        mapElem['automatic'] = !mapElem['automatic'];
        this.setState({
            dataInstitutions: Array.from(instMap.values()),
        });
    }

    automaticTemplate(rowData){
        return <Checkbox inputId="binary" checked={rowData['automatic']}
                         onChange={()=>this.onChangeAutomaticCheck(rowData)}/>
    }

    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        this.confMsgEnabled = <ConfirmationMessage ref={this.setConfirmationRefEnabled}
                                                   invisible={true}
                                                   legend="¿Está seguro que desea hacer cambios en la información?"
                                                   action={this.enableForm}/>;
        this.confMsgSave = <ConfirmationMessage ref={this.setConfirmationRefSave}
                                                invisible={true}
                                                legend="¿Está seguro que desea guardar los cambios?"
                                                action={this.saveDataFideicomisoConf}/>;
        return <CustodiaBBVAView
            isDisabledData={this.state.isDisabledData}
            username={this.state.username}
            password={this.state.password}
            baseUrl={this.state.baseUrl}
            trustClient={this.state.trustClient}
            isLoading={this.state.isLoading}
            tabItems={this.state.tabItems}
            activeIndex={this.state.activeIndex}
            dataInstitutions={this.state.dataInstitutions}
            messagesGrowl={messagesGrowl}
            confMsgEnabled={this.confMsgEnabled}
            confMsgSave={this.confMsgSave}
            onChangeData={this.onChangeData}
            openConfMsgEnabled={this.openConfMsgEnabled}
            openConfMsgSave={this.openConfMsgSave}
            restartData={this.restartData}
            handleTabChange={this.handleTabChange}
            automaticTemplate={this.automaticTemplate}
            openConfMsgSaveInst={this.openConfMsgSaveInst}
        />
    }
}